// VITE_API_URL is the Rails backend base URL (exposed via VITE_ prefix)
export const API_URL = (import.meta.env.VITE_API_URL as string) || ''
export const GOOGLE_CLIENT_ID = (import.meta.env.VITE_GOOGLE_CLIENT_ID as string) || ''
